<ng-template #entityEditTemplate
             let-title="title">
  <app-settings-invitations-edit #editComponent
                                        (modelChange)="createModel$.next($event)"
                                        [creating]="true"
                                        [loading]="(loaded$ | async) === false"
                                        [model]="createModel$ | async"
                                        [readonly]="false"
                                        [stereotyped]="false"
                                        [title]="title">
  </app-settings-invitations-edit>
</ng-template>

<app-entity-overview #overviewComponent
                            [entityEditTemplate]="entityEditTemplate"
                            [entityOverviewBaseComponent]="this"
                            [stereotyped]="false"
                            detailLink="invitations"
                            module="settings">
</app-entity-overview>
